<template>
  <div class="team-player-container">
    <el-form class="user-from" label-width="100px" >
      <el-form-item v-if="setInfo" class="label-line-height" label="球队Logo" >
        <el-upload
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          :data="dataObj"
          :action="qiniuUp"
          :accept="accept"
          class="upload-size"
          list-type="picture-card">
          <img v-if="team.badge" :src="team.badge | ImageFormats" >
          <i v-if="!team.badge" class="el-icon-plus avatar-uploader-icon"/>
          <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过5Mb</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img :src="dialogImageUrl" width="100%">
        </el-dialog>
      </el-form-item>
      <el-form-item v-if="setInfo" class="label-line-height label-bill" label="球队合影" >
        <el-upload
          :on-success="billHandleSuccess"
          :on-error="handleError"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          :data="dataObj"
          :action="qiniuUp"
          :accept="accept"
          class="upload-size"
          list-type="picture-card">
          <img v-if="team.background" :src="team.background | ImageBillFormats" >
          <i v-if="!team.background" class="el-icon-plus avatar-uploader-icon"/>
          <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过5Mb</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img :src="dialogImageUrl" width="100%">
        </el-dialog>
      </el-form-item>
      <el-form-item label="所属会员单位">
        <el-input :value="clubName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="球队名称">
        <el-input v-model="team.longName"></el-input>
      </el-form-item>
      <el-form-item label="球队简称">
        <el-input v-model="team.name"></el-input>
      </el-form-item>
      <el-form-item label="所在组别">
        <el-select v-model="team.groupId" filterable placeholder="请选择">
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-radio-group v-model="team.auditStatus">
          <el-radio :label="0">待审核</el-radio>
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="1">未通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态" >
        <el-radio-group v-model="team.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="-1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="球员名单" >
        <el-button @click="dialogTableVisible=true" >添加</el-button>
        <el-button style="float: right;" @click="exportData" :loading="exportLoading">导出球员秩序册</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%;"
      border>
      <el-table-column
        label="序号"
        type="index">
      </el-table-column>
      <el-table-column
        label="头像"
        prop="profile">
        <template slot-scope="scope" >
          <img :src="scope.row.profile | ImageFormats" class="profile" >
        </template>
      </el-table-column>
      <el-table-column
        label="姓名"
        prop="trueName">
      </el-table-column>
      <el-table-column
        label="位置"
        prop="position">
        <template slot-scope="scope" >
          <el-select v-model="scope.row.position" @change="updatePlayerInfo" placeholder="请选择">
            <el-option
              v-for="item in ['前锋','后卫','守门员']"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="号码"
        prop="jerseyNo">
        <template slot-scope="scope" >
          <el-input v-model="scope.row.jerseyNo" type="Number" @change="updatePlayerInfo" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatBirthDate"
        label="生日"
        prop="birthDay">
      </el-table-column>
      <el-table-column
        label="证件号"
        prop="certificateNum">
      </el-table-column>
      <el-table-column
        label="年级"
        prop="grade">
        <template slot-scope="scope" >
          <el-input v-model="scope.row.grade" type="text" @change="updatePlayerInfo" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="是否最佳"
        prop="mvp">
        <template slot-scope="scope" >
          <el-select v-model="scope.row.mvp" @change="updatePlayerInfo" placeholder="请选择">
            <el-option
              v-for="item in [{value: 1, label:'是'}, {value: 0, label:'否'}]"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="是否队长"
        width="120px"
        prop="role">
        <template slot-scope="scope" >
          <el-select v-model="scope.row.role" @change="updatePlayerInfo" placeholder="请选择">
            <el-option
              v-for="item in [{value: 1, label:'是'}, {value: 0, label:'否'}]"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope" >
          <el-row>
            <el-button type="danger" @click="deletePlayer(scope.row.id)" >删除</el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div style="width: 100%; height: 30px" >
    </div>
    <!--  官员start -->
    <div style="">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="4">
          <span class="title">选择俱乐部</span>
          <el-select v-model="office[0].orgId" filterable placeholder="请选择" @change="changeOrgItem(0)">
            <el-option
              v-for="item in clubList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span class="title" style="padding-top: 10px; display: block;">选择领队</span>
          <el-select v-model="office[0].id" filterable placeholder="请选择">
            <el-option
              v-for="item in coachList[0]"
              :key="item.id"
              :label="item.trueName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">选择俱乐部</span>
          <el-select v-model="office[1].orgId" filterable placeholder="请选择" @change="changeOrgItem(1)">
            <el-option
              v-for="item in clubList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span class="title" style="padding-top: 10px; display: block;">选择副领队</span>
          <el-select v-model="office[1].id" filterable placeholder="请选择">
            <el-option
              v-for="item in coachList[1]"
              :key="item.id"
              :label="item.trueName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">选择俱乐部</span>
          <el-select v-model="office[2].orgId" filterable placeholder="请选择" @change="changeOrgItem(2)">
            <el-option
              v-for="item in clubList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span class="title" style="padding-top: 10px; display: block;">选择主教练</span>
          <el-select v-model="office[2].id" filterable placeholder="请选择" >
            <el-option
              v-for="item in coachList[2]"
              :key="item.id"
              :label="item.trueName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">选择俱乐部</span>
          <el-select v-model="office[3].orgId" filterable placeholder="请选择" @change="changeOrgItem(3)">
            <el-option
              v-for="item in clubList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span class="title" style="padding-top: 10px; display: block;">选择助理教练</span>
          <el-select v-model="office[3].id" filterable placeholder="请选择">
            <el-option
              v-for="item in coachList[3]"
              :key="item.id"
              :label="item.trueName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">选择俱乐部</span>
          <el-select v-model="office[4].orgId" filterable placeholder="请选择" @change="changeOrgItem('4')">
            <el-option
              v-for="item in clubList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <span class="title" style="padding-top: 10px; display: block;">选择队医</span>
          <el-select v-model="office[4].id" filterable placeholder="请选择">
            <el-option
              v-for="item in coachList[4]"
              :key="item.id"
              :label="item.trueName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-button type="primary" @click="updateTeamPlayer" style="margin-top: 25px">保存</el-button>
    </div>
    <!-- 官员 end -->
    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialogTableVisible" title="添加球员">
      <el-form class="user-from" >
        <el-row :gutter="24" >
          <el-col :span="10" >
            <el-form-item label="俱乐部列表" >
              <el-select v-model="clubId" filterable @change="getOrganizationPlayerList" placeholder="请选择">
                <el-option
                  v-for="item in clubList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item :span="6" label="搜索球员" >
              <el-input v-model="playerName" @change="getOrganizationPlayerList(false)" placeholder="搜索球员名字" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="padding-top: 40px">
            <el-radio-group v-model="position">
              <el-radio :label="1">守门员</el-radio>
              <el-radio :label="0">其他</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="filterPlayerList"
        @selection-change="SelectPlayerChange">
        <el-table-column
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          property="profile"
          label="头像">
          <template slot-scope="scope" >
            <img :src="scope.row.profile | ImageFormats" class="profile" >
          </template>
        </el-table-column>
        <el-table-column
          property="trueName"
          label="姓名">
        </el-table-column>
        <el-table-column
          property="grade"
          label="年级">
        </el-table-column>
        <el-table-column
          property="position"
          label="位置">
        </el-table-column>
        <el-table-column
          :formatter="formatBirthDate"
          width="100"
          property="birthday"
          label="出生日期">
        </el-table-column>
        <el-table-column
          property="certificateNum"
          width="150"
          label="证件号">
        </el-table-column>
      </el-table>
      <el-row class="btn" >
        <el-button @click="dialogTableVisible=false">取消</el-button>
        <el-button type="primary" @click="addTeamPlayer">保存</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { getQiniuUploadToken } from '@/api/site'
import { ImageFormat, showMessage, varConfig, ConstConfig } from '@/utils'
import { getClubEdit } from '@/api/club'
import { createTeam, getOrganizationList, getGroupTeam, getOrganizationPlayerList, updateTeam, role,
  getValidOrgList, getMatchInfo, getCoachList, adminAddTeamPlayers, adminDeleteTeamPlayers, exportTeamData, getMatchGroupList } from '@/api/match'

export default {
  name: 'TeamPlayerList',
  data() {
    return {
      list: [],
      club: [],
      clubId: '',
      clubList: [],
      coach: [],
      coachList: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: []
      },
      dialogTableVisible: false,
      routerParams: {},
      team: {},
      afterAddPlayerList: [],
      role: role,
      setInfo: {
        logo: null,
        bill: null
      },
      playerName: null,
      playerList: [],
      filterPlayerList: [],
      allowTeamSignup: 0,
      newTeamForm: {
        name: null,
        auditState: null,
        status: null
      },
      position: 0,
      office: [
        { role: '领队', id: '', orgId: '' },
        { role: '副领队', id: '', orgId: ''  },
        { role: '主教练', id: '', orgId: ''  },
        { role: '助理教练', id: '', orgId: ''  },
        { role: '队医',  id: '', orgId: '' }
      ],
      dataObj: { token: '' },
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      dialogVisible: false,
      dialogImageUrl: '',
      exportLoading: false,
      groupList: '',
      clubName: ''
    }
  },
  created() {
    this.routerParams = this.$route.params
    this.getCoachList(0)
    this.getCoachList(1)
    this.getCoachList(2)
    this.getCoachList(3)
    this.getCoachList(4)
    this.getTeamInfo()
    this.getOrganizationList()
    this.getMatchInfo()
    this.getQiniuToken()
    this.getMatchGroups()
  },
  computed: {
  },
  watch: {
    position(newVal, oldVal) {
      if (newVal == 1) {
        this.filterPlayerList = this.playerList.filter(item => {
            return item.position == '守门员'
          })
      } else {
        this.filterPlayerList = this.playerList.filter(item => {
            return item.position !== '守门员'
          })
      }
    }
  },
  methods: {
    handleRolesChange() {

    },
    goTeams() {
      this.$router.push({ name: 'LeagueGroupTeams', params: { id: 1, gid: 1 }})
    },
    goGames() {
      this.$router.push({ name: 'LeagueGroupGames', params: { id: 1, gid: 1 }})
    },
    getClubInfo(orgId) {
      if (!orgId) return
      const params = { id: orgId }
      getClubEdit(params).then((resolve) => {
        this.clubName = resolve.data && resolve.data.name
      }, (reject) => {
        console.log(reject)
      })
    },
    addPlayers() {
      this.listLoading = true
      createTeam(this.newTeamForm).then((resolve) => {
        this.listLoading = false
        if (resolve) {
          this.dialogVisibleNewTeam = false
          this.$message({
            message: '创建球队成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    },
    getMatchGroups() {
      getMatchGroupList({ matchId: this.routerParams.id, pageSize: 9999 }).then((resolve) => {
        this.groupList = resolve.data.list
        this.groupList = _.filter(this.groupList, function (item) {
          return item.status == 0
        })
      })
    },
    getOrganizationList() {
      const params = {
        pageSize: 9999
      }
      getValidOrgList(params).then((resolve) => {
        const emptyClub = {id: 0, name: '选择空'}
        this.clubList = resolve.data.list
        this.clubList.unshift(emptyClub)
      })
    },
    getTeamInfo() {
      let params = {
        groupId: this.routerParams.gid,
        teamId: this.routerParams.tid
      }
      getGroupTeam(params).then((resolve) => {
        this.team = resolve.data.team
        let coaches = this.team.coaches
        /*
        this.setInfo.logo = this.team.badge
        this.setInfo.logo = this.team.badge
        console.log(this.team)
        */
//        this.list = this.team.players
        const guard = _.filter(this.team.players, function (item) {
          return item.position == '守门员'
        })
        const other = _.filter(this.team.players, function (item) {
          return item.position != '守门员'
        })
        this.list = _.concat(guard, other)
        this.coach = this.team.coaches

        // this.getCoachList(this.team.organizationId)
        if (this.team.organizationId) {
          this.getOrganizationPlayerList(this.team.organizationId)
        }
        coaches.filter(item => {
          if (item.role === '领队') {
            this.office[0].orgId = item.organizationId
            this.office[0].id = item.id
            this.getCoachList(0)
          } else if (item.role === '副领队') {
            this.office[1].orgId = item.organizationId
            this.office[1].id = item.id
            this.getCoachList(1)
          } else if (item.role === '主教练') {
            this.office[2].orgId = item.organizationId
            this.office[2].id = item.id
            this.getCoachList(2)
          } else if (item.role === '助理教练') {
            this.office[3].orgId = item.organizationId
            this.office[3].id = item.id
            this.getCoachList(3)
          } else if (item.role === '队医') {
            this.office[4].orgId = item.organizationId
            this.office[4].id = item.id
            this.getCoachList(4)
          }
        })

        this.getClubInfo(this.team.organizationId)
      })
    },
    getOrganizationPlayerList(clubId) {
      if (clubId) {
        this.clubId = clubId
      }
      const params = {
        pageSize: 9999,
        status: 2,
        payStatus: 1,
        trueName: this.playerName
      }
      if (this.clubId) {
        params.organizationId = this.clubId
      }
      getOrganizationPlayerList(params).then((resolve) => {
        const playerList = resolve.data && resolve.data.list
        // 排除已选球员
        /*this.playerList = []
        for (let i = 0; i < playerList.length; i++) {
          const obj = _.find(this.list, function(item) {
            return item.playerId === playerList[i].id
          })
          if (!obj) {
            this.playerList.push(playerList[i])
          }
        }*/
        this.playerList = playerList
        if (this.position == 1) {
          this.filterPlayerList = playerList.filter(item => {
              return item.position == '守门员'
            })
        } else {
          this.filterPlayerList = playerList.filter(item => {
              return item.position !== '守门员'
            })
        }
    })
    },
    formatBirthDate: function(row, column) {
      const date = row[column.property]
      return date && date.substring(0, 10);//moment(date).format('YYYY-MM-DD')
    },
    SelectPlayerChange(player) {
      this.afterAddPlayerList = player
    },
    addTeamPlayer() {
      let params = {
        teamId: this.team.id
      }
      if(this.afterAddPlayerList.length > 0) {
        const players = []
        this.afterAddPlayerList.forEach((item) => {
          item.jerseyNo = parseInt(item.jerseyNo)
          item.playerId = item.id
          let obj = Object.assign({}, item)
          delete obj.id
          players.push(obj)
        })
        params.players = JSON.stringify(players)
      }
      delete params.id
      adminAddTeamPlayers(params).then((res) => {
        const data = res.data
        if(data) {
          this.getTeamInfo()
          this.afterAddPlayerList = []
          this.$message({
            message: '添加球员成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    },
    updateTeamPlayer() {
      let params = _.cloneDeep(this.team)
      params.coaches = JSON.stringify(this.office)
      /*
      if (this.coach.length > 0) {
        const selectedCoaches = this.coach.map((item) => {
          return item.id
        })
        params.coaches = JSON.stringify(selectedCoaches)
      }
      */
//    params.organizationId = this.clubId //TODO 俱乐部下的球员/官员是否统一俱乐部
      if (!this.team.name) {
        this.$message({
          message: '球队简称不能为空',
          type: 'error',
          showClose: true,
          duration: 1000
        })
        return
      }
      const len = this.getStrLength(this.team.name)
      if (this.team.name && len > 10) {
        this.$message({
          message: '球队简称长度不能大于5个中文字符',
          type: 'error',
          showClose: true,
          duration: 1000
        })
        return
      }
      params.teamId = params.id
      params.players = JSON.stringify(this.list)
      delete params.id
      updateTeam(params).then((res) => {
        const data = res.data
        if(data) {
          this.getTeamInfo()
          this.afterAddPlayerList = []
          this.$message({
            message: '修改成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          if (params.groupId !== this.routerParams.gid) {
              const obj = {
                id: this.routerParams.id,
                gid: params.groupId,
                tid: this.routerParams.tid
              }
             this.$router.push({name: 'LeagueGroupTeamPlayers', params: obj})
            location. reload()
          }
        }
      })
    },
    getStrLength (str) {
      var cArr = str.match(/[^\x00-\xff]/ig);
      return str.length + (cArr == null ? 0 : cArr.length);
    },
    getCoachList(index) {
      let params = {
        pageSize: 9999
      }
      if (this.office[index]) {
        params.organizationId = this.office[index].orgId
      }
      getCoachList(params).then((resolve) => {
        this.coachList[index] = resolve.data.list
      })
    },
    changeOrgItem(index) {
      this.office[index].id = ''
      let params = {
        pageSize: 9999
      }
      if (this.office[index] && this.office[index].orgId) {
        params.organizationId = this.office[index].orgId
      }
      getCoachList(params).then((resolve) => {
        this.coachList[index] = resolve.data.list
      })
    },
    selectCoach(index) {
      getCoachList(index);
    },
    updatePlayerInfo() {
      this.updateTeamPlayer()
    },
    deletePlayer(playerId) {
      const params = {
        ids: playerId
      }
      adminDeleteTeamPlayers(params).then((res) => {
        const data = res.data
        if(data) {
          this.getTeamInfo()
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    },
    setCoachList(item) {
      this.coach = item
    },
    getMatchInfo() {
      const params = {
        id: this.routerParams.id
      }
      getMatchInfo(params).then((res) => {
        const data = res.data
        if (data && data.match) {
          this.allowTeamSignup = data.match.allowTeamSignup
        }
      })
    },
    exportData() {
      const params = {
        teamId: this.routerParams.tid,
        groupId: this.routerParams.gid
      }
      this.exportLoading = true
      exportTeamData(params).then((resolve) => {
        const data = resolve.data
        if(data && data.email) {
          this.$message({
            message: '导出数据成功，请在邮箱:' + data.email + '查收',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
        this.exportLoading = false
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    handleSuccess(response) {
      this.team.badge = response.hash
    },
    billHandleSuccess(response) {
      this.team.background = response.hash
    },
    handleError(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 156)
    },
    ImageBillFormats(img) {
      return ImageFormat.squareImageView1(img, 240, 120)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" >
  .team-player-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }
    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }
    .btn {
      padding-top: 15px;
      text-align: right;
    }
    .profile {
      width: 56px;
      height: 56px;
    }
    .el-dialog__wrapper {
      .el-dialog__body {
        .el-table {
          max-height: 180px;
          overflow-y: scroll;
        }
      }

      .el-table::before {
        height: 0;
      }
    }

    .label-line-height {
      .el-upload {
        width: 80px;
        height: 80px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 78px;
          height: 78px;
          line-height: 78px !important;
          text-align: center;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .label-bill {
      .el-upload {
        width: 240px;
        height: 120px;
        .avatar-uploader-icon {
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
</style>
